const resources = {
  general: {
    search: 'Search',
    reset: 'Reset',
    close: 'Close',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    name: 'Name',
    action: 'Action | Actions',
    ipAddress: 'IP address',
    sync: 'Synchronize',
    syncStatus: 'Sync status',
    version: 'Version',
    note: 'Note',
    general: 'General',
    stats: 'Stats',
    macAddress: 'MAC Address',
    type: 'Type',
    size: 'Size',
    true: 'True',
    false: 'False',
    content: 'Content',
    emailAddress: 'Email address',
    next: 'Next',
    cancel: 'Cancel',
    assign: 'Assign',
    user: 'User | Users',
    disabled: 'Disabled',
    language: 'Language',
    english: 'English',
    slovak: 'Slovak',
    news: 'News',
    account: 'Account | Accounts',
    subscription: 'Subscription | Subscriptions',
    status: 'Status | Statuses',
  },
  app: {
    navigation: 'Navigation',
    schedule: 'Schedule | Schedules',
    design: 'Design',
    box: 'Box | Boxes',
    library: 'Library',
    media: 'Media',
    setting: 'Settings | Settings',
    monitoring: 'Monitoring',
    administration: 'Administration',
    layoutEditor: 'Layout editor',
    userManagement: 'User management',
    organizationManagement: 'Organization management',
    boxManagement: 'Box management',
    device: 'Device | Devices',
    screen: 'Screen | Screens',
    layout: 'Layout | Layouts',
    dashboard: 'Dashboard',
    playlist: 'Playlist | Playlists',
    management: 'Management',
    planning: 'Planning',
    newsEditor: 'News editor',
    specialWidget: 'Special widget | Special widgets',
  },
  auth: {
    login: 'Login',
    email: 'Email',
    password: 'Password',
    register: 'Register',
    forgotPassword: 'Forgot password?',
    username: 'Username',
    confirmPassword: 'Confirm password',
    reset: 'Reset',
  },
  admin: {
    createUser: 'Create user',
    deleteUser: 'Delete user | Delete users',
    editUser: 'Edit user',
    createOrganization: 'Create organization',
    deleteOrganization: 'Delete organization | Delete organizations',
    editOrganization: 'Edit organization',
    confirmPassword: 'Confirm password',
    organization: 'Organization | Organizations',
    role: 'Role | Roles',
    usersFilterPlaceholder: 'Name or Email',
    organizationsFilterPlaceholder: 'Name',
    box: 'Box | Boxes',
    boxesFilterPlaceholder: 'Name, sync status or version',
    deleteBox: 'Delete box | Delete boxes',
    editBox: 'Edit box | Edit boxes',
    createBox: 'Create box | Create boxes',
    permission: 'Permission | Permissions',
    subscriptionUser: 'Subscription user',
    maxBoxes: 'Max number of boxes',
    icon: 'Icon | Icons',
    specialWidget: 'Special widget | Special widgets',
    specialWidgetsFilterPlaceholder: 'Name or type',
    createSpecialWidget: 'Create special widget',
    deleteSpecialWidget: 'Delete special widget | Delete special widgets',
    editSpecialWidget: 'Edit special widget',
    audioSource: 'Audio source',
    imageSource: 'Image source',
    videoSource: 'Video source',
    pdfSource: 'PDF source',
    webSource: 'Web source',
  },
  box: {
    filterPlaceholder: 'Name, IP address, sync status or version',
    boxDateTime: 'Box date & time',
    boxUptime: 'Box uptime',
    boxHddTemperature: 'Box HDD temperature',
    boxHddUsage: 'Box HDD usage',
    boxCpuLoad: 'Box CPU load',
    boxRamUsage: 'Box RAM usage',
    boxSwapUsage: 'SWAP usage',
    videoOutput: 'Video output | Video outputs',
    displayVolume: 'Display {identifier} volume',
    volume: 'Volume',
    displayResolution: 'Display resolution',
    boxStorageSpace: 'Storage',
    deleteBox: 'Delete box | Delete boxes',
    syncBox: 'Synchronize box | Synchonize boxes',
    lastStatusUpdate: 'Last status update',
    osVersion: 'Android OS version',
    activated: 'Activated',
  },
  library: {
    filterPlaceholder: 'Name or type',
    playlistsFilterPlaceholder: 'Name',
    deleteMedia: 'Delete this media?',
    uploadPlaceholder: 'Drop files here or click here to upload',
    preview: 'Preview',
    createPlaylist: 'Create playlist',
    editPlaylist: 'Edit playlist',
    assignPlaylist: 'Assign playlist',
    deletePlaylist: 'Delete playlist | Delete playlists',
    playlistEditor: 'Playlist editor',
    event: 'Event | Events',
  },
  schedule: {
    createNewEvent: 'Create new event',
    editEvent: 'Edit event',
    title: 'Title',
    date: 'Date',
    startDate: 'Start date',
    endDate: 'End date',
    startTime: 'Start time',
    endTime: 'End time',
    color: 'Color | Colors',
    month: 'Month | Months',
    week: 'Week | Weeks',
    year: 'Year | Years',
    repeat: 'Repeat',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    novermber: 'November',
    december: 'December',
  },
  design: {
    position: 'Position',
    size: 'Size',
    audioControls: 'Audio controls',
    animation: 'Animation | Animations',
    widget: 'Widget | Widgets',
    contentBrowser: 'Content browser',
    library: 'Library',
    property: 'Property | Properties',
    noWidgetSelectedMsg: 'No widget selected',
    noWidgetSelectedDescription: 'Click one of the widgets in layout editor to edit its properties',
    noWidgetsMsg: 'No widgets',
    noWidgetsDescription: 'Drag widget from Content browser & drop it to layout editor to create widgets',
    noLibraryMediaMsg: 'No media',
    noLibraryMediaDescription: 'Please upload media on Media page to use them in layout editor',
    visible: 'Visible',
    top: 'Top',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    bottom: 'Bottom',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    color: 'Color | Colors',
    background: 'Background',
    text: 'Text',
    height: 'Height',
    width: 'Width',
    font: 'Font',
    alignment: 'Alignment',
    image: 'Image',
    feedTextPlaceholder: 'Feed text',
    video: 'Video',
    webpage: 'Webpage',
    youtube: 'YouTube',
    shellCommand: 'Shell command',
    pdf: 'PDF',
    url: 'URL',
    ticker: 'Ticker',
    audio: 'Audio',
    clock: 'Clock',
    embed: 'Embed',
    powerpoint: 'Powerpoint',
    event: 'Event | Events',
    newEvent: 'New event',
    uploadMedia: 'Upload media',
    startTime: 'Start time',
    endTime: 'End time',
    createEvent: 'Create event',
    type: 'Type | Types',
    allowDeformation: 'Allow deformation',
    margin: 'Margin',
    padding: 'Padding',
    zIndex: 'Z-index',
    value: 'Value',
    newAnimation: 'New animation',
    createAnimation: 'Create animation',
    startPosition: 'Start position',
    endPosition: 'End position',
    duration: 'Duration (seconds)',
    repeat: 'Repeat',
    togglePicker: 'Toggle picker',
    rotation: 'Rotation',
    createTimelinePoint: 'Create point on timeline',
    newState: 'New state',
    state: 'State | States',
    startOpacity: 'Start opacity',
    endOpacity: 'End opacity',
    degree: 'Degree | Degrees',
    createScreen: 'Create screen | Create screens',
    deleteScreen: 'Delete screen | Delete screens',
    screensFilterPlaceholder: 'Name, width or height',
    createLayout: 'Create layout | Create layout',
    deleteLayout: 'Delete layout | Delete layout',
    layoutsFilterPlaceholder: 'Name',
    assignLayout: 'Assign layout | Assign layouts',
    webContent: 'Web content',
    option: 'Option | Options',
    opacity: 'Opacity',
    start: 'Start',
    end: 'End',
    time: 'Time | Times',
    connection: 'Connection',
    address: 'Address | Addresses',
    port: 'Port | Ports',
    password: 'Password',
    vncViewer: 'VNC Viewer',
    durationBetweenPages: 'Duration between pages',
    loop: 'Loop',
    volume: 'Volume',
    hardwareAcceleration: 'Hardware acceleration',
    twitter: 'Twitter',
    rss: 'RSS',
    facebook: 'Facebook',
    twitterOptions: 'Twitter options',
    hashtag: 'Hashtag',
    user: 'User',
    facebookPageID: 'Facebook page ID',
    youtubeOptions: 'YouTube options',
    special: 'Special',
    web: 'Web',
    videoPlayerType: 'Video player type',
    magio: 'Magio TV',
    magioOptions: 'Magio options',
  },
  settings: {
    invoice: 'Invoice | Invoices',
    invoicesFilterPlaceholder: 'Amount or date',
    amount: 'Amount',
    date: 'Date',
  },
};

export default resources;
